import {
  EmptyStateAction,
  EmptyStateImage,
  EmptyStateWithIllustration,
} from 'components/EmptyState'

interface ErrorBlockProps {
  title: string
  description: string
  click: () => void
  actionWord: string
}

const ErrorBlock = ({
  title,
  description,
  actionWord,
  click,
}: ErrorBlockProps) => {
  return (
    <EmptyStateWithIllustration title={title} description={description}>
      <EmptyStateImage imageSrc="/sertifikasi-pendidik/images/errors/img-session-expired.png" />
      <EmptyStateAction color="black" onClick={click}>
        {actionWord}
      </EmptyStateAction>
    </EmptyStateWithIllustration>
  )
}

export default ErrorBlock
